// removed by extract-text-webpack-plugin
module.exports = {"container":"toast-message__container__3kDmn","content":"toast-message__content__3XMKJ","cancel-icon":"toast-message__cancel-icon__2Qkv3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/global/toast-message.scss
// module id = 1302
// module chunks = 1